import styled from "styled-components";

export const FormContainer = styled.div`
	.form {
		max-height: 158px;
		height: 158px;
		width: 100%;
		display: flex;
	}
	.custom-select {
		margin: auto 0;
		margin-left: 20px;
	}
	.form-input {
		width: 100%;
		margin: auto;
		padding: 0px 20px;
	}
	.error {
		.css-13cymwt-control {
			border-color: #ae1515;
		}
		color: #ae1515;
		&.text-area {
			border: 1px solid #ae1515;
			border-radius: 5px;
		}
	}
	.label-container{
		gap: 10xp;
	}
	.label-title{
		font-weight: 800;
	}
	.label-title-second {
		color: #666666;
		padding: 5px 0px;
	}
	.video-input{
		padding-top: 10px;
	}
	.video-input-ag::placeholder{
		font-size: 30px;
	}
`;

export const Div = styled.div``;
